<div id="abilitySurveyWrap" [ngClass]="{'none':!judgeFinish}" >

	<div class="common-back-btn-sight" (click)="close()" style="z-index: 99;" *ngIf="isOpenClass==0">
	    <span>×</span>
	 </div>
	<div class="header" *ngIf="showIntroduce">
		<div class="title">{{title}}</div>
	</div>
	<div class="header" [ngClass]="{'z0':!showsceneBtnEnable}" *ngIf="!showIntroduce" style="background: transparent;">
		<app-countdown *ngIf="isDataLoad" [totalSeconds]="remainTime" [remindSeconds]="60" (onTimeout)="onTimeout(true)" (onTimeReminder)="onTimeReminder(true)"></app-countdown>
		<div class="btn-simulation"  *ngIf="currentSceneTip"  (click)="showSceneDialog()">情景描述{{currentSceneTip.index + 1}}</div>
	</div>

	<ul id="questionItem">
    <li class="current finish" *ngIf="showIntroduce && !oldGuidePage" style="transition: top .3s linear;">
      <div class="card-container">
        <div class="center-section">
          <!-- 前测 -->
          <ng-container *ngIf="typeId == 1">
            <div class="desc">
              优秀的领导者，不仅要识人，更需要<span class="highlight">知己</span>。
            </div>
            <div class="question">
              <span class="highlight">{{ abilityName }}</span> 你目前的水平如何？
            </div>
            <img class="picture" style="margin-top: 0.6rem;margin-bottom: 0.5rem;width: 63%;" src="{{assetsRoute}}/picture/abilitysurvey/picture1.png" alt="">
          </ng-container>
          <!--  后测-->
          <ng-container *ngIf="typeId == 2">
            <div class="desc">
              了解变化，才有提升的可能。
            </div>
            <div class="question">
              想了解你团队领导力的变化吗？
            </div>
            <img class="picture" src="{{assetsRoute}}/picture/abilitysurvey/picture2-1.png" alt="">
            <div class="sub-txt">下面，你将置身于两个场景中，扮演产品经理和销售主管的角色，通过一系列测验题，获取团队领导力成长报告。</div>
		  </ng-container>
        </div>
        <div class="tips">
          <h3 class="title">温馨提醒：</h3>
          <ul class="tip-list">
            <li [innerHTML]="typeId === 2 ? '以下检测需要花费约 <span class=\'highlight\'>25-30</span> min完成。':'学前检测是为了了解你目前在<span class=\'highlight\'>'+ abilityName +'</span>这个模块的水平'"></li>
            <li [innerHTML]="typeId === 2 ? '测评只能做 <span class=\'highlight\'>1</span> 次，请认真对待哦！':'以下检测需要花费约<span class=\'highlight\'> 5 </span>分钟完成' "></li>
            <li [innerHTML]="typeId === 2 ? '中途被打断，可能会影响计分。':'检测只能做 <span class=\'highlight\'>1</span> 次，请认真对待哦！' "></li>
          </ul>
        </div>
      </div>
    </li>
		<li *ngFor="let item of questionsList;let i= index;" [ngClass]="{'finish':item.completeFlag,'showeffective':item.showEffective,'showinvalid':item.showInvalid,'questionItem':item.type == 'question'}">
			<div *ngIf="item.type == 'scene'" [ngClass]=" 'scene scene' + item.sceneId " >
				<div class="sceneInner">
					<div class="sceneSimpleTitle">情景{{item.sceneIndex+1}}</div>
					<p [innerHtml]="item.sceneTitle"></p>
					<p [innerHtml]="item.sceneDesc"></p>
          <div class="pc-btn" *ngIf="isPC" style="position: absolute;left: 50%;bottom: .2rem;transform: translateX(-50%);" (click)="doExercises()">下一步</div>
				</div>
			</div>

			<div *ngIf="item.type == 'question'" class="question-info">
				<input type="hidden" class="simulationIndex" value="{{item.sceneIndex}}" />
				<div><span class="bold">({{item.qstIndex}}/{{qstCount}})</span>&nbsp;{{item.questionsName}} 请分别选出<span class="clr-effective">最有效</span>和<span class="clr-invalid">最无效</span>的措施。</div>
				<div class="option">
					<div class="option-item" *ngFor="let subItem of item.surveySceneOptions;">
						{{subItem.optionsName}}
					</div>
				</div>
				<div class="answer">
					<div class="btn-effective" (click)="showEffective(item);" [ngClass]="{'on': item.effectiveOptionsNo != 0 }">
						<p class="fs36">最有效措施</p>
						<p class="fs28" *ngIf="item.effectiveOptionsNo == 0">点击此处选择</p>
						<p class="fs28" *ngIf="item.effectiveOptionsNo != 0">已经选择:
							<span  *ngFor="let subItem2 of item.surveySceneOptions;let z=index;" >
								<span *ngIf=" subItem2.optionsNo == item.effectiveOptionsNo ">{{letterList[z]}}</span>
							</span>
						</p>
					</div>
					<div class="btn-invalid" (click)="showInvalid(item);" [ngClass]="{'on': item.invalidOptionsNo != 0 }">
						<p class="fs36">最无效措施</p>
						<p class="fs28" *ngIf="item.invalidOptionsNo == 0">点击此处选择</p>
						<p class="fs28" *ngIf="item.invalidOptionsNo != 0">已经选择:
							<span *ngFor="let subItem2 of item.surveySceneOptions;let z=index;" >
								<span *ngIf=" subItem2.optionsNo == item.invalidOptionsNo ">{{letterList[z]}}</span>
							</span>
						</p>
					</div>
				</div>
        <div class="pc-type-pagination" *ngIf="isPC">
          <div class="pc-btn" [ngClass]="{'disabled':item.qstIndex == 1}" (click)="preQA(item.qstIndex)">上一题</div>
          <div class="pc-btn" [ngClass]="{'disabled': item.effectiveOptionsNo == 0 || item.invalidOptionsNo == 0}" (click)="nextQA(item.qstIndex)">
            <span *ngIf="item.qstIndex < qstCount">下一题</span>
            <span *ngIf="item.qstIndex == qstCount">查看结果</span>
          </div>
        </div>
			</div>

			<div class="answer-conver" *ngIf="item.type == 'question'" (click)="showSurQuestionInfo(item)">
				<div class="effectiveOption" (click)="cancelEvent($event)">
					<div class="chktitle">请选择最有效措施</div>
					<div class="option-item" [ngClass]="{'on': subItem.optionsNo == item.effectiveOptionsNo }" *ngFor="let subItem of item.surveySceneOptions;let j=index;" (click)="saveEffectiveItem(item,subItem.optionsNo)">
						{{letterList[j]}}
					</div>
				</div>
				<div class="invalidOption" (click)="cancelEvent($event)">
					<div class="chktitle">请选择最无效措施</div>
					<div class="option-item" [ngClass]="{'on': subItem.optionsNo == item.invalidOptionsNo }" *ngFor="let subItem of item.surveySceneOptions;let j=index;" (click)="saveInvalidItem(item,subItem.optionsNo)">
						{{letterList[j]}}
					</div>
				</div>
			</div>
			<!--<div class="swipTip" *ngIf="item.qstIndex==2 && !item.completeFlag && showSwiptipEable ">-->
				<!--<div class="swipTip-img"></div>-->
				<!--<p class="swipTip-txt">向下滑动可查看上一题哦！</p>-->
				<!--<div class="swipTip-btn" (click)="removeSwipTip()">朕知道了</div>-->
			<!--</div>-->
      <div class="swipTip" *ngIf="item.qstIndex==1 && !item.completeFlag && showSwiptipEable ">
      <!--<div class="swipTip" *ngIf="!item.completeFlag && showSwiptipEable&&(!isSelectedBad||!isSelectedGood) ">-->
        <p class="swipTip-txt">两项都选完才能进入下一题！</p>
        <div class="swipTip-btn" (click)="removeSwipTip()">我知道啦</div>
        <div class="answer">
          <img src="{{assetsRoute}}/picture/experience/arrow-1.png" alt="">
          <img src="{{assetsRoute}}/picture/experience/arrow-2.png" alt="">
        </div>
        <div class="answer">
          <div class="btn-effective">
            <p class="fs36">最有效措施</p>
            <p class="fs28">点击此处选择</p>
          </div>
          <div class="btn-invalid">
            <p class="fs36">最无效措施</p>
            <p class="fs28">点击此处选择</p>
          </div>
        </div>
      </div>
			<div *ngIf="item.type == 'question' && item.qstIndex == qstCount && item.completeFlag && !isPC " class="btn-finish" (click)="saveSurveyInfo(1)">提交</div>
		</li>
	</ul>
	<div class="footer">
		<div *ngIf="!showEnterTxt && showArrowEnable && !isPC" class="icon-arrowUp" [ngClass]="{'dark':enterEnable,'stopanmiate':stopArrowAnimate}"></div>
		<div *ngIf="showEnterTxt&& !isPC" class="enter-text">进入</div>
    <div *ngIf="isPC && showPCBtn && showIntroduce" class="pc-btn" (click)="goNext()">进入{{title}}</div>
	</div>
</div>
<div id="simulationTip" *ngIf="showsceneTipEnable">
	<div class="inner">
		<div [ngClass]=" 'scene scene' + currentSceneTip.sceneId " >
			<div class="sceneInner">
				<div class="sceneSimpleTitle">情景{{currentSceneTip.index+1}}</div>
        <p [innerHtml]="currentSceneTip.sceneTitle"></p>
        <p [innerHtml]="currentSceneTip.sceneDesc"></p>
			</div>
		</div>
		<div class="closer" (click)="closeSceneDialog()"></div>
	</div>
</div>
<div id="tip1">测验还有 1 分钟了。</div>
<div id="tip2" style="text-align: center">
    <div id="tip2_picture" style="text-align: center">
      <img src="{{assetsRoute}}/picture/feature/clock.svg " style="width: 1.5rem" alt="" />
<!--      <embed src='{{assetsRoute}}/picture/feature/clock.svg' type="image/svg+xml" width="100%" height="100%"/>-->
    </div>
    <p style="position: absolute; left: 50%; transform: translateX(-50%)">到点了，测验结束</p>
</div>
<app-com-tip [type]="'tip'" (onSure)="continueSure()" (onCancel)="continueCancel()" *ngIf="continueTipEnable" [desText]="'之前的测验已完成了<span class=spec>' + surveyBaseInfo.finishQuestionCount +  '</span>题，要继续吗？'" [sureText]="'重新开始'" [cancelText]="'继续测验'"></app-com-tip>
<app-com-tip [type]="'tip'" (onSure)="exitSure()" (onCancel)="exitCancel()" *ngIf="exitTipEnable" [desText]="'何不一鼓作气，做完测验？'" [sureText]="'退出'" [cancelText]="'继续测验'"></app-com-tip>
<!--<app-com-tip [type]="'tip'" *ngIf="!isPreTestFinished && typeId==2 && examId!==0" (onCancel)="goPreSurvey()" [desText]="'请先完成能力诊断'" [cancelText]="'立即前往'" [sureText]="''" ></app-com-tip>-->




// WEBPACK FOOTER //
// ./src/app/learning-camp/camp-survey/camp-survey.component.html